import React, { useCallback, useContext, useEffect, useState } from 'react';
import Button from 'b2b-ui-components-lib/lib/components/button';

import { CustomTable } from 'common/components/table/table';
import TableLoader from 'home/view/manage-feasibility/components/organisms/addressProcessAOI/loader/table-loader';

import { AppContext } from 'App';

import { generateToken, getOrders } from 'home/view/manage-feasibility/services';
import {
  AOI_TMO_REDIRECTED,
  AUTH_TOKEN,
  CART_ID,
  DEFAULT_TOAST_MSG,
  ERROR_TOAST,
  FEASIBILITY_SUCCESS,
  LEAD_ID,
  MULTI_SITE_MODULE_ID,
  ORDER_ID,
  SUMMARY_AUTH_TOKEN
} from 'home/view/manage-feasibility/constants';
import { AOI_TMO_TABLE_HEADERS } from './constants';

import './index.scss';
import { findParamFromUrl, isAuthForDev, isDevEnv, setInSessionStorage } from 'common/utils/app.utils';
import { PRODUCT_NAME, ROUTES } from 'common/constants/app.constants';
import { AUTHORIZATION_HEADER, MODULE_ID } from 'home/common/constants/constants';
import { prepareSortModel } from 'common/components/table/table.constant';
import { IS_MULTIPLE_SORT } from 'dedicated/components/plan-and-configuration-aoi/configure-plan-pricing-constant';
import { paginationLength } from 'dedicated/components/plan-and-configuration/table/custom-table.constant';
import TmoModal from '../../components/tmoModal/TmoModal';
import appConfig from '../../../../../config/config';

const TrackOrderAOI = ({ history }) => {
  const { setToast } = useContext(AppContext);
  const ORDER_TYPE = 'orderType';
  // const AOI_TMO_REDIRECTED = 'AOI_TMO_REDIRECTED';
  const [showLoader, setShowLoader] = useState(false);
  const [totalSitesProcessed, setTotalSitesProcessed] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [tableData, setTableData] = useState([]);
  const [parameters, setParameters] = useState({});
  const [pageLength, setPageLength] = useState(1);
  const [initialRows, setInititalRows] = useState(10);
  const [numberOfRowsToShow, setNumberOfRowsToShow] = useState(10);

  const getLoginPayload = (isKyc, { orderId, leadId }) => {
    const accessToken = localStorage.getItem('accessToken') || '';
    const payload = {
      aehAccessToken: accessToken,
      source: 'SELF_CARE'
    };

    if (isKyc) {
      payload['orderId'] = orderId;
    } else {
      payload['leadId'] = leadId;
      payload['pnqToken'] = false;
    }

    return payload;
  };

  const generateLoginToken = async (isKyc = false, rowItem) => {
    try {
      setShowLoader(true);
      const { leadId, cartId, orderId, status } = rowItem;

      const payload = getLoginPayload(isKyc, rowItem);
      const { res, err } = await generateToken(payload, isKyc);
      if (res) {
        const { headers: { authorization_token = '', authorization = '' } = {}, data } = res;

        if (data) {
          setInSessionStorage(MULTI_SITE_MODULE_ID, AOI_TMO_REDIRECTED, true);
          setShowLoader(true);

          if (isKyc) {
            setInSessionStorage(MULTI_SITE_MODULE_ID, SUMMARY_AUTH_TOKEN, authorization ? authorization : authorization_token);
            setInSessionStorage(MULTI_SITE_MODULE_ID, ORDER_ID, orderId);
            setInSessionStorage(MULTI_SITE_MODULE_ID, ORDER_TYPE, 'NEW');
            setInSessionStorage(MULTI_SITE_MODULE_ID, PRODUCT_NAME, 'DSL');
          } else {
            setInSessionStorage(MULTI_SITE_MODULE_ID, CART_ID, cartId);
            setInSessionStorage(MULTI_SITE_MODULE_ID, LEAD_ID, leadId);
            setInSessionStorage(MODULE_ID, AUTHORIZATION_HEADER, authorization ? authorization : authorization_token);
            setInSessionStorage(MULTI_SITE_MODULE_ID, AUTH_TOKEN, authorization ? authorization : authorization_token);
            setInSessionStorage(MULTI_SITE_MODULE_ID, FEASIBILITY_SUCCESS, status === 'FEASIBILITY_COMPLETED');
          }

          setTimeout(() => {
            let redirectUrl = isKyc ? ROUTES.AOI.DEDICATED_ORDER_SUMMARY : ROUTES.AOI.DEDICATED_BULK_FEASIBILITY;
            if (isDevEnv() && isAuthForDev()) {
              redirectUrl = redirectUrl + '?isAuth=' + findParamFromUrl('isAuth', false);
            }

            if (isDevEnv() && isAuthForDev()) {
              redirectUrl = redirectUrl + '&productType=' + 'DSL';
            } else {
              redirectUrl = redirectUrl + '?productType=' + 'DSL';
            }

            redirectUrl = redirectUrl + '&journey=' + 'trackLead';
            redirectUrl = redirectUrl + '&platform=' + 'AEH';

            if (isKyc) {
              redirectUrl = redirectUrl + '&orderId=' + orderId;
            } else {
              redirectUrl = redirectUrl + '&leadId=' + leadId;
              redirectUrl = redirectUrl + '&cartId=' + cartId;
              redirectUrl = redirectUrl + '&status=' + status;
            }

            history.push(redirectUrl);
            //window.location.href(redirectUrl)
          }, 1000);
        }
      } else if (err) {
        const errorMsg = (err && err.response && err.response.data && err.response.data.errorMsg) || DEFAULT_TOAST_MSG;

        setShowLoader(false);
        setToast(true, errorMsg, ERROR_TOAST);

        let redirectUrl = ROUTES.ERROR_PAGE;
        history.push(redirectUrl);
        throw new Error(errorMsg);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const handleRedirect = (rowItem) => {
    const isKyc = rowItem && rowItem.orderId ? true : false;
    generateLoginToken(isKyc, rowItem);
  };

  const getRowData = (rowItem) => {
    const { leadId, orderId, customerName, status, numberOfSites, actionRequired } = rowItem;
    const statusWithSpace = status.replaceAll(/_/g, ' ').toLowerCase();
    return {
      leadId: actionRequired ? (
        <span onClick={() => handleRedirect(rowItem)} style={{ color: '#027bfc', cursor: 'pointer' }} className="track_link">
          {leadId}
        </span>
      ) : (
        <span>{leadId} </span>
      ),
      customerName,
      status: (
        <span className="order_status">
          {statusWithSpace}
          {/* {status !== 'ORDER_SUBMITTED' && (
            <div role="button" className="track_link" onClick={() => handleRedirect(rowItem)}>
              Proceed
            </div>
          )} */}
        </span>
      ),
      numberOfSites,
      action: (
        <span>
          {actionRequired && (
            <div className="track_link" onClick={() => handleRedirect(rowItem)}>
              {/* <i className="material-icons">arrow_forward</i> */}
              <span className="btn">Proceed</span>
            </div>
          )}
        </span>
      )
    };
  };

  const handleCreateNewRequest = useCallback((newTab = false) => {
    let redirectUrl = ROUTES.AOI.DEDICATED_HOME;
    if (isDevEnv() && isAuthForDev()) {
      redirectUrl = redirectUrl + '?isAuth=' + findParamFromUrl('isAuth', false);
    }

    if (isDevEnv() && isAuthForDev()) {
      redirectUrl = redirectUrl + '&productType=' + 'DSL';
    } else {
      redirectUrl = redirectUrl + '?productType=' + 'DSL';
    }

    redirectUrl = redirectUrl + '&platform=' + 'AEH';
    redirectUrl = redirectUrl + '&utm_source=' + 'AEH_site';
    redirectUrl = redirectUrl + '&utm_medium=' + 'dsl-data-connectivity';
    redirectUrl = redirectUrl + '&utm_campaign=' + 'our_products';
    if (newTab) {
      //window.open(redirectUrl, '_blank');
      history.push(redirectUrl);
    } else {
      history.push(redirectUrl);
    }
  }, []);
  const onClickNewRequestBtn = () => {
    let redirectUrl = ROUTES.AOI.DEDICATED_HOME;
    if (isDevEnv() && isAuthForDev()) {
      redirectUrl = redirectUrl + '?isAuth=' + findParamFromUrl('isAuth', false);
    }

    if (isDevEnv() && isAuthForDev()) {
      redirectUrl = redirectUrl + '&productType=' + 'DSL';
    } else {
      redirectUrl = redirectUrl + '?productType=' + 'DSL';
    }

    window.open(redirectUrl, '_blank');
  };

  const fetchOrders = async ({ page = 1, size = 10 }) => {
    // setNumberOfRowsToShow(10);
    try {
      setShowLoader(true);

      let params = {
        // token: localStorage.getItem('accessToken'),
        productName: 'DSL',
        source: 'SELF_CARE',
        page: page - 1,
        size
      };

      params = {
        ...parameters,
        ...params
      };

      const config = {
        // baseURL:appConfig.apiBaseUrl,
        headers: {
          token: localStorage.getItem('accessToken')
        }
      };

      const { res, err } = await getOrders(params, config);
      if (res) {
        const {
          status,
          data: { content, pageNumber, pageSize, totalElement, totalPages }
        } = res;

        if (res === null || Object.keys(res).length === 0 || (Array.isArray(content) && content.length === 0)) {
          handleCreateNewRequest();
          setTableData([]);
          setTotalPages(0);
          setTotalSitesProcessed(0);
          setShowLoader(false);
        } else if (status === 200) {
          const tableRowList = [];
          setShowLoader(false);
          setTotalSitesProcessed(totalElement);
          setTotalPages(totalPages);

          if (content && content.length > 0) {
            // const effectiveIndex = (page-1) * size;
            const indexing = (page * 10) / size - 1;
            let effectiveIndex = 0;
            if (indexing >= 0) {
              effectiveIndex = Math.ceil(indexing);
            } else {
              effectiveIndex = Math.floor(indexing);
            }
            //  effectiveIndex = (page*10/size) -1 ;
            const effectiveSize = effectiveIndex + size;

            content
              // .filter((item) => item.numberOfSites > 0)
              .filter((_item, index) => index >= effectiveIndex && index < effectiveSize)
              .forEach((rowItem) => {
                const rowData = getRowData(rowItem);
                tableRowList.push(rowData);
              });
          }
          setPageLength(Math.ceil(totalElement / size));
          // if (totalElement % size === 0) {
          //   // paginationLength = totalElement/pageSize;
          //   setPageLength(totalElement / size);
          // } else {
          //   // paginationLength = totalElement/pageSize + 1;
          //   setPageLength(Math.ceil(totalElement / size));
          // }
          setTableData(tableRowList);
        }
      } else {
        const errorMsg = (err && err.response && err.response.data && err.response.data.errorMsg) || DEFAULT_TOAST_MSG;

        setTableData([]);
        setTotalPages(0);
        setTotalSitesProcessed(0);
        setShowLoader(false);
        handleCreateNewRequest();

        // setToast(true, errorMsg, ERROR_TOAST);
        throw new Error(errorMsg);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const onTableStateChange = ({ sort, currentPage, showRows, activeColumn }) => {
    let pageNumber = currentPage;
    setNumberOfRowsToShow(showRows);
    if (showRows !== initialRows) {
      setInititalRows(showRows);
      pageNumber = 1;
    }
    fetchOrders({ page: pageNumber, size: showRows });
    // sortModel: prepareSortModel(sort, activeColumn, IS_MULTIPLE_SORT)
    // const test = '1';
  };

  const onClearFilter = ({ setShowRows, setCurrentPage }) => {};

  const onCellClickHandler = ({ rowData, headerConfig }) => {};

  useEffect(() => {
    setTimeout(() => {
      fetchOrders();
    }, 5000);
  }, []);

  return (
    <div className="track_order_aoi">
      <TmoModal
        pageLength={pageLength}
        setPageLength={setPageLength}
        fetchOrders={fetchOrders}
        setParameters={setParameters}
        getRowData={getRowData}
        setTableData={setTableData}
        setShowLoader={setShowLoader}
        setTotalSitesProcessed={setTotalSitesProcessed}
        setTotalPages={setTotalPages}
        renderHeaderSection={() => {}}
        headers={AOI_TMO_TABLE_HEADERS}
        showLoader={showLoader}
        tableData={tableData}
        onCellClickHandler={onCellClickHandler}
        totalPages={totalPages - 1}
        totalSitesProcessed={totalSitesProcessed}
        onTableStateChange={onTableStateChange}
        showSearch={false}
        multipleSort={false}
        onClearFilter={onClearFilter}
        paginationLength={pageLength}
        renderMessage={() => {}}
        onSortChange={() => {}}
        onPageChange={() => {}}
        handleCreateNewRequest={handleCreateNewRequest}
        numberOfRowsToShow={numberOfRowsToShow}
        setNumberOfRowsToShow={setNumberOfRowsToShow}
      />
      {/* <div className="create_new_request">
        <Button className="activebtn" onClick={() => handleCreateNewRequest(true)}>
          Buy Now
        </Button>
      </div>
      <div className="existing_orders_aoi">
        <CustomTable
          hideClearFilter
          loader={<TableLoader />}
          renderHeaderSection={() => {}}
          showLoader={showLoader}
          headers={AOI_TMO_TABLE_HEADERS}
          contents={tableData}
          onCellClickHandler={onCellClickHandler}
          totalPages={totalPages - 1}
          totalRecords={totalSitesProcessed}
          onChange={onTableStateChange}
          showSearch={false}
          multipleSort={false}
          onClearFilter={onClearFilter}
          paginationLength={paginationLength}
          renderMessage={() => {}}
          onSortChange={() => {}}
          onPageChange={() => {}}
        />
      </div> */}
    </div>
  );
};

export default TrackOrderAOI;
